import {ClusterIconInfo} from '@google/markerclustererplus';

import {checkIsBeforeYear1945} from '../libs/check-before-year-1945';

/**
 * Returns information for the cluster icon
 */
const getClusterIconInfo = (
  markers: Array<google.maps.Marker>
): ClusterIconInfo => {
  const areWorksCreatedBeforeYear1945 = markers.map(marker => {
    const year = marker.get('year');
    return checkIsBeforeYear1945(year);
  });
  const allWorksAreCreatedBeforeYear1945 = areWorksCreatedBeforeYear1945.every(
    isBeforeYear1945 => isBeforeYear1945 === true
  );
  const allWorksAreCreatedAfterYear1945 = areWorksCreatedBeforeYear1945.every(
    isBeforeYear1945 => isBeforeYear1945 === false
  );
  const iconStylesIndex =
    (allWorksAreCreatedAfterYear1945 && 2) ||
    (allWorksAreCreatedBeforeYear1945 && 1) ||
    0;

  return {
    text: String(markers.length),
    index: iconStylesIndex + 1, // index must be styles array index + 1
    title: ''
  };
};

export default getClusterIconInfo;
